import type { DeepLink } from '@ps/web-martech-cms-types';
import type React from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import URLParse from 'url-parse';

import { select } from '@swf/core/store';

const CMSDeepLink: React.FC<DeepLink> = ({ url_query_param: param }) => {
  const query = useSelector(select.location.getQuery);
  const url = query[param];
  const sanitizedUrl = /^(?!http|ftp|tftp|ws|ssh|telenet|smtp|cmot)\w+:\/\/.*/;

  useEffect(() => {
    if (url && sanitizedUrl.test(url)) {
      const parsedUrl = new URLParse(url);
      window.location.href = parsedUrl.href;
    }
  });

  return null;
};

export default CMSDeepLink;
